<template>
<body>
  <div>
    <div class="container2">
      <div class="question">In der Organisation werden IT-Systeme genutzt, um kollaboratives Arbeiten ausreichend zu fördern.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it" @input="update" />
      <span :style="warning()" class="rangeValue"> {{it}} </span></div>
    </div>

    <div class="container2">
      <div class="question">In der Organisation werden IT-Systeme genutzt, um den Wissensaustausch effektiv zu verbessern.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it2" @input="update2" />
      <span :style="warning2()" class="rangeValue"> {{it2}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Unsere IT-Systeme können schnell an neue Geschäftsanforderungen angepasst werden.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it3" @input="update3" />
      <span :style="warning3()" class="rangeValue"> {{it3}} </span></div>
    </div>

    <div class="container2">
      <div class="question">In der Organisation können den Mitarbeitern alle benötigten Daten zeitnah zur Verfügung stellen.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it4" @input="update4" />
      <span :style="warning4()" class="rangeValue"> {{it4}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Die Organisation passt IT-Systeme stetig an die Wünsche und Anforderungen ihrer Mitarbeiter an.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it5" @input="update5" />
      <span :style="warning5()" class="rangeValue"> {{it5}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Die Organisation nutzt IT-Systeme, um mit ihren Mitarbeitern transparent über relevante unternehmensbezogene Themen zu kommunizieren.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="it6" @input="update6" />
      <span :style="warning6()" class="rangeValue"> {{it6}} </span></div>
    </div>


    <div class="container3">
      <button class="button_save" @click="evaluateForm">auswerten</button>
    </div>


  </div>

    
  </body>
</template>

<script>
  export default {
    props: ["ITValue", "ITValue2", "ITValue3", "ITValue4", "ITValue5", "ITValue6"],
    data(){
      return {
        it: this.ITValue,
        it2: this.ITValue2,
        it3: this.ITValue3,
        it4: this.ITValue4,
        it5: this.ITValue5,
        it6: this.ITValue6
      }
    },
    methods: {   
      update(a){
        this.it = a.target.value
      },
      update2(b){
        this.it2 = b.target.value
      },
      update3(c){
        this.it3 = c.target.value
      },
      update4(d){
        this.it4 = d.target.value
      },
      update5(e){
        this.it5 = e.target.value
      },
      update6(f){
        this.it6 = f.target.value
      },

      warning:function(){
        if(this.it == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it == 4)
          return{
            color: "#A1A250",
          }
        if (this.it == 3)
          return{
            color: "#E09A34",
          }
        if (this.it == 2)
          return{
            color: "#E87735",
          }
        if (this.it == 1)
          return{
            color: "#F44336",
          }

      },
      warning2:function(){
        if(this.it2 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it2 == 4)
          return{
            color: "#A1A250",
          }
        if (this.it2 == 3)
          return{
            color: "#E09A34",
          }
        if (this.it2 == 2)
          return{
            color: "#E87735",
          }
        if (this.it2 == 1)
          return{
            color: "#F44336",
          }

      },
      warning3:function(){
        if(this.it3 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it3 == 4)
          return{
            color: "#A1A250",
          }
        if (this.it3 == 3)
          return{
            color: "#E09A34",
          }
        if (this.it3 == 2)
          return{
            color: "#E87735",
          }
        if (this.it3 == 1)
          return{
            color: "#F44336",
          }

      },
      warning4:function(){
        if(this.it4 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it4 == 4)
          return{
            color: "#A1A250",
          }
        if (this.it4 == 3)
          return{
            color: "#E09A34",
          }
        if (this.it4 == 2)
          return{
            color: "#E87735",
          }
        if (this.it4 == 1)
          return{
            color: "#F44336",
          }

      },
      warning5:function(){
        if(this.it5 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it5 == 4)
          return{
            color: "#A1A250",
          }
        if (this.it5 == 3)
          return{
            color: "#E09A34",
          }
        if (this.it5 == 2)
          return{
            color: "#E87735",
          }
        if (this.it5 == 1)
          return{
            color: "#F44336",
          }

      },
      warning6:function(){
        if(this.it6 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.it6 == 4)
          return{
            color: "#A1A250",
          }
        if (this.it6 == 3)
          return{
            color: "#E09A34",
          }
        if (this.it6 == 2)
          return{
            color: "#E87735",
          }
        if (this.it6 == 1)
          return{
            color: "#F44336",
          }

      },
      evaluateForm(){
        if (this.it==null) {
          this.it='3' 
        } 
        if (this.it2==null) {
          this.it2='3'
        } 
        if (this.it3==null) {
          this.it3='3'
        } 
        if (this.it4==null) {
          this.it4='3'
        } 
        if (this.it5==null) {
          this.it5='3'
        } 
        if (this.it6==null) {
          this.it6='3'
        }
        this.$emit('update:ITValue', this.it)
        this.$emit('update:ITValue2', this.it2)
        this.$emit('update:ITValue3', this.it3)
        this.$emit('update:ITValue4', this.it4)
        this.$emit('update:ITValue5', this.it5)
        this.$emit('update:ITValue6', this.it6)
        this.$emit('saved')
      }
    }
  };
</script>


<style>

body{
  margin: 0;
  padding: 0;
  background-color: #fff;
  font-family: 'Karla', Arial, Helvetica, sans-serif;

}
.topmargin{
  margin-top: 30px;
}

.container2{
  position: relative;
  height: 50 px;
  width: 600px;
  margin: 50px auto;
  font-family: 'Karla', Arial, Helvetica, sans-serif;

}
.question{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.slider{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.container2 .mySlider {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 600px;
  height: 25px;
  background-color: #00FFFF;
  border-radius: 20px;
  outline:none;
  opacity: 0.7;
  transition: opacity .2s ease-in;
  -webkit-transition: opacity .2s ease-in;

}

.container2 .mySlider:hover{
  opacity: 1;
}

.container2 .mySlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #0A2342;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::moz-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #0A2342;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #F5F5F5;

}

.container2 .mySlider::-webkit-slider-thumb:hover {
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.5)
}
.container2 .rangeValue {
  position: absolute;
  height: 40px;
  width: 60px;
  right: -105px;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #2f3640;
  color: #2f3640;
  background-color: #F5F5F5;
  font-weight: 600;
  font-family: 'Karla', Arial, Helvetica, sans-serif;
  text-align: center;
  line-height: 38px;
  font-size: 22px;
}

.container2 .rangeValue::before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  background-color: #F5F5F5;
  top: 14px;
  left: -6px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #2f3640;
  border-left: 1px solid #2f3640;
  border-right: 1px solid transparent;
  transform: rotate(45deg);
}

.container3 {
  height: 40px;
  width: 150px;
  margin: 20px auto;
  justify-content: center;
}

.button_save {
  font-size: 15px;
  height: 40px;
  width: 130px;
  background-color: #0A2342;
  margin: 0px 10px;
  border-color: #00FFFF;
  color:aliceblue;
  justify-content: center;
  font-family: 'Poppins', 'Arial Black', Gadget, sans;


}

@keyframes anim {
  0%{
    right: -20px;
  }
  25%{
    right: -10px
  }
  50%{
    right: -30px
  }
  70%{
    right: -10px
  }
  100%{
    right: -20px

  }
}



</style>